import * as React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Box } from '@mui/material';
import { useState } from 'react';
import NpListContainer from '../../../containers/employeemng/np/NpListContainer';
import NpFormContainer from '../../../containers/employeemng/np/NpFormContainer';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`np-tabpanel-${index}`}
      aria-labelledby={`np-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `np-tab-${index}`,
    'aria-controls': `np-tabpanel-${index}`,
  };
}

const NpTabs = ({ employee, edit }) => {
  const [selectTab, setSelectTab] = useState(0);
  const handleChange = (event, newTab) => {
    setSelectTab(newTab);
  };
  return (
    <div>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={selectTab}
            onChange={handleChange}
            aria-label="np tabs"
          >
            <Tab label="국책과제" {...a11yProps(0)} />
          </Tabs>
        </Box>
        <TabPanel value={selectTab} index={0}>
        { edit && <NpFormContainer employee={employee}/>}
            <NpListContainer employee={employee}/>
        </TabPanel>
       
      </Box>
    </div>
  );
};

export default NpTabs;
